<header cdx-header>
  <cdx-header-global>
    <div class="main-tabs">
      <div class="header_tab">
        @if (isAdminUser) {
        <app-admin-link></app-admin-link>
        }
        <button
          mat-icon-button
          class="notifications-icon"
          routerLinkActive="is-active"
          [routerLink]="['/order-management/watch-alert']"
        >
          <mat-icon class="material-icons-outlined">notifications</mat-icon>
        </button>

        <button mat-icon-button aria-label="Settings" id="settings-button">
          <mat-icon class="material-icons md-dark">settings</mat-icon>
        </button>
      </div>
      <div>
        <button
          [matMenuTriggerFor]="menu"
          #menuTrigger="matMenuTrigger"
          class="account-button"
        >
          <mat-icon class="material-icons-sharp">account_circle</mat-icon>
          <p>{{ this.userName }}</p>
        </button>
        <mat-menu
          #menu="matMenu"
          xPosition="before"
          yPosition="below"
          class="logout-menu"
        >
          <form id="logoutForm" method="post"></form>
          <button mat-menu-item class="button-menu-item" (click)="logout()">
            Log out
          </button>
        </mat-menu>
      </div>
    </div>
  </cdx-header-global>
</header>
